import { render, staticRenderFns } from "./thank-you-debt-relief-popup.vue?vue&type=template&id=5f70ae58"
import script from "./thank-you-debt-relief-popup.vue?vue&type=script&lang=js"
export * from "./thank-you-debt-relief-popup.vue?vue&type=script&lang=js"
import style0 from "../../assets/styles/thank-you-popup.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports